import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { Box, Button } from "@mui/material";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
      return; // Prevent further execution
    } catch (e) {
      console.error("Login error:", e);
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Button
        variant='contained'
        onClick={() => handleLogin()}
        sx={{ textTransform: "none" }}
      >
        Sign in Using WIMS Account
      </Button>
    </Box>
  );
};
